import axios from "axios";

import ApiException from "./ApiException";
import config from "@/app.config.json";

import { useUserStore } from "@/stores/userStore";

const urlBase = `${config.urlApi}/Titulares`;  //import.meta.env.VITE_URL_API;

const urls = {
  obter: `${urlBase}`,
  obterPorId: `${urlBase}`,
  gerar: `${urlBase}/Gerar`,
  download: `${urlBase}/Download`,
}

function getToken(): string {
  const userStore = useUserStore();
  
  if (userStore.getToken) {
    return `Bearer ${userStore.getToken}`;
  }
  
  return "";
}

export const obterPorId = (id: number): Promise<Titular> => {
  return new Promise((resolve, reject) => {

    const params = {
      id: id
    }

    console.log("obterPorId", id);
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(`${urls.obterPorId}/${id}`, { params })
      .then((response) => {
        return resolve(response.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter por id")));
  });
};

export const obter = (): Promise<Titular[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obter)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export async function gerar(): Promise<Titular> {
  try {
    // Configurar token de autorização
    axios.defaults.headers.common.Authorization = getToken();

    return (await axios.post(urls.gerar)).data
  } catch (error: any) {
    throw new ApiException(error || "Falha ao gerar arquivo de titulares");
  }
}


export async function download(id: number): Promise<boolean> {
  try {
    // Configurar token de autorização
    axios.defaults.headers.common.Authorization = getToken();

    const response = await axios.get(`${urls.download}/${id}`, { params: { id }, responseType: 'blob' });

    const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/octet-stream' });

    // tentar obter o nome do arquivo a partir do header Content-Disposition
    // tentar obter o nome do arquivo a partir do header Content-Disposition
    let filename = "titulares.csv";

    // se não veio no header, gerar titulares_DDMMYYYY_HHMMSS.csv
    //if (!filename) {
    const d = new Date();
    const pad = (n: number) => n.toString().padStart(2, "0");
    const DD = pad(d.getDate());
    const MM = pad(d.getMonth() + 1);
    const YYYY = d.getFullYear();
    const HH = pad(d.getHours());
    const mm = pad(d.getMinutes());
    const SS = pad(d.getSeconds());
    filename = `titulares_${DD}${MM}${YYYY}_${HH}${mm}${SS}.csv`;
    //}

    // disparar download automático
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    // retornar true para indicar sucesso da operação
    return true;
  } catch (error: any) {
    throw new ApiException(error || "Falha ao gerar arquivo de titulares");
  }
}

export interface Titular {
  id: number;
  dataGeracao: string;
  qtde: number;
  conteudo: string | null;
}
